// Dark/light mode button switch value (checked or not)
const toggleSwitch = document.getElementById('themeSwitch');

// User system preference betwwen dark and light mode
if (
    window.matchMedia &&
    localStorage.getItem('theme') == null &&
    window.matchMedia('(prefers-color-scheme: dark)').matches
    ) {
        localStorage.setItem('theme', 'dark');
        toggleSwitch.checked = true;
}

// Current mode choose
const currentTheme = localStorage.getItem('theme');

if (currentTheme) {
    document.documentElement.setAttribute('data-theme', currentTheme);
    if (currentTheme === 'dark') {
        toggleSwitch.checked = true;
    }
}

function switchTheme(e) {
    if (e.target.checked) {
        document.documentElement.setAttribute('data-theme', 'dark');
        localStorage.setItem('theme', 'dark');
    }

    else {
        document.documentElement.removeAttribute('data-theme');
        localStorage.setItem('theme', '');
    }
}

toggleSwitch.addEventListener('change', switchTheme, false);